export const WEALTH_DETAIL_SLUGS = [
  'active-saving-account',
  'interest-account',
  'isa-solutions',
  'structured-savings',
];

export const isWealthDetailPage = (pageSlug) =>
  WEALTH_DETAIL_SLUGS.includes(pageSlug);
